import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';

import storage25Image from 'assets/images/size-guide/unit--25sqft.webp';
import storage50Image from 'assets/images/size-guide/unit--50sqft.webp';
import storage75Image from 'assets/images/size-guide/unit--75sqft.webp';
import storage100Image from 'assets/images/size-guide/unit--100sqft.webp';
import storage150Image from 'assets/images/size-guide/unit--150sqft.webp';
import storage200Image from 'assets/images/size-guide/unit--200sqft.webp';
import storage300Image from 'assets/images/size-guide/unit--300sqft.webp';
import outdoorImage from 'assets/images/size-guide/unit--parking-outdoor.webp';
import parkingImage from 'assets/images/size-guide/unit--parking.webp';
import lockerImage from 'assets/images/size-guide/unit--locker.webp';
import workspaceImage from 'assets/images/size-guide/unit--workspace.webp';
import wineImage from 'assets/images/size-guide/unit--wine.webp';

const icons = {
	25: storage25Image,
	50: storage50Image,
	75: storage75Image,
	100: storage100Image,
	150: storage150Image,
	200: storage200Image,
	300: storage300Image,
};

function getStorageClass(squareFootage) {
	const storageClasses = Object.keys(icons);

	for (const storageClass of storageClasses) {
		if (squareFootage <= storageClass) {
			return storageClass;
		}
	}
	return storageClasses.at(-1);
}

function getUnitIconSrc(type, amenities, squareFootage) {
	switch (type) {
		case 'locker':
			return lockerImage;
		case 'parking_space':
		case 'outdoor':
			if (amenities?.covered) {
				return parkingImage;
			}
			return outdoorImage;
		case 'workspace':
			return workspaceImage;
		case 'wine_storage':
			return wineImage;
		default:
			return icons[getStorageClass(squareFootage)];
	}
}

export default function UnitIcon({
	amenities,
	squareFootage,
	type,
	className,
	...rest
}) {
	return (
		<Image
			{...rest}
			className={className ? `unit-icon ${className}` : 'unit-icon'}
			alt="unit icon"
			lazyLoad
			src={getUnitIconSrc(type, amenities, squareFootage)}
		/>
	);
}

UnitIcon.propTypes = {
	amenities: PropTypes.object,
	squareFootage: PropTypes.number,
	type: PropTypes.string,
	className: PropTypes.string,
};
